<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-29 16:04:17
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-11-12 14:59:24
-->
<template>
  <!-- 下拉列表组件 -->
  <div>
    <v-btn icon
           v-if="showData.length <= 0">
      <v-icon @click.stop="drawer = !drawer"
              class="material-icons">tune</v-icon>
    </v-btn>
    <v-sheet v-else
             width="100%"
             color="#F5F5F5"
             class="d-flex align-start justify-space-between pa-2  rounded-lg">
      <v-btn icon
             height="32"
             class="mt-1"
             width="32"
             @click.stop="drawer = !drawer">
        <v-icon class="material-icons">tune</v-icon>
      </v-btn>
      <v-sheet class="d-flex aqlign-start transparent">
        <v-chip-group column
                      active-class="primary--text">
          <v-chip close
                  @click:close="close(name, index)"
                  v-for="(name, index) in showData"
                  :key="name.field_name">
            <span style="max-width:130px;overflow:hidden;text-overflow:ellipsis; white-space: nowrap;">
              {{ INT(name.field_description) }}</span>
          </v-chip>
        </v-chip-group>
      </v-sheet>
      <v-btn icon
             class="mt-1"
             height="32"
             width="32"
             @click.stop="cancel">
        <v-icon class="material-icons">close</v-icon>
      </v-btn>
    </v-sheet>
    <!-- 功能过滤 -->
    <v-navigation-drawer v-model="drawer"
                         fixed
                         right
                         class="bigboxdrawer"
                         style="font-size: 13px;color: rgba(0, 0, 0, 0.78);border-bottom-left-radius:6px;border-bottom-right-radius:6px;"
                         mini-variant
                         mini-variant-width="376"
                         temporary>
      <div class="dv">
        <span></span>
        <span>
          <v-icon @click.stop="drawer = !drawer"
                  class="material-icons">close</v-icon>
        </span>
      </div>
      <div style="padding-bottom: 80px">
        <v-expansion-panels accordion
                            :flat="true"
                            :multiple="false"
                            v-model="panels"
                            :tile="true"
                            active-class="activePanelClass">
          <v-expansion-panel style="border-bottom: 1px solid #e0e0e0;"
                             v-for="(item, index) in systemFieldMetaData"
                             :key="index">
            <oneFilter :operatorSelect="filterOperators(item)"
                       :flag="flag"
                       @getData="getData"
                       :resetParams="resetField(item.field_name)"
                       :item="item" />
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
      <mrc_ess_submitBtn @cancel="cancel"
                         :cancelText="$t('label_reset')"
                         style="position:absolute;bottom:0;margin-top: -80px;z-index: 2"
                         backgroundColor="#ffffff"
                         :loading="btnloading"
                         @success="success"></mrc_ess_submitBtn>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { weekdaysMin } from 'moment'
import oneFilter from './mrc_ess_advance'
import { get_dict_name } from '@/service/api/data_dictionary'
/**
 * iconShow   是否显示下拉图标
 */
export default {
  components: { oneFilter },
  props: {
    btnloading: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '业务功能',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    uuid: {
      type: [String, Array],
      default: '',
    },
    systemFieldMeta: {
      type: Array,
      default: () => [],
    },
    defaultSearch: {
      type: Array,
    },
  },
  model: {
    event: 'success',
    prop: 'defaultSearch',
  },
  data () {
    return {
      drawer: null,
      showMenu: false,
      list: [],
      operatorSelect: [],
      searchData: [],
      showData: [],
      resetParams: false,
      resetParamsField: '',
      flag: true,
      panels: [],
      systemFieldMetaData: [],
    }
  },
  computed: {
    // 数据类型 String 逻辑运算符 具体逻辑看综合搜索的文档
    stringSelect () {
      // notIn，in，notBetween，between，
      // notLike，<，>，，isNotNull，isNull，like，>=，!=，=,<=
      const dataSelect = []
      const stringArr = [
        '=',
        '!=',
        'in',
        'notIn',
        'isNull',
        'isNotNull',
        'like',
        'notLike',
      ]
      this.operatorSelect.forEach((item) => {
        if (stringArr.includes(item.dict_value)) {
          dataSelect.push(item)
        }
      })
      return dataSelect
    },
    // 数据类型 int 逻辑运算符 具体逻辑看综合搜索的文档
    intSelect () {
      // notIn，in，notBetween，between，
      // notLike，<，>，isNotNull，isNull，like，>=，!=，=，<=
      const dataSelect = []
      const stringArr = [
        '=',
        '!=',
        '>',
        '<',
        '>=',
        '<=',
        'isNull',
        'isNotNull',
        'in',
        'notIn',
        'notBetween',
        'between',
      ]
      this.operatorSelect.forEach((item) => {
        if (stringArr.includes(item.dict_value)) {
          dataSelect.push(item)
        }
      })
      return dataSelect
    },
    // 数据类型 String 参照的逻辑运算符 具体逻辑看综合搜索的文档
    advanceSelect () {
      // notIn，in，notBetween，between，
      // notLike，<，>，isNotNull，isNull，like，>=，!=，=，<=
      const dataSelect = []
      const stringArr = ['=', '!=', 'isNull', 'isNotNull', 'in', 'notIn']
      this.operatorSelect.forEach((item) => {
        if (stringArr.includes(item.dict_value)) {
          dataSelect.push(item)
        }
      })
      return dataSelect
    },
    dateTimeSelect () {
      // notIn，in，notBetween，between，
      // notLike，<，>，isNotNull，isNull，like，>=，!=，=，<=
      const dataSelect = []
      const stringArr = [
        '=',
        '!=',
        'isNull',
        'isNotNull',
        'notBetween',
        'between',
        '>',
        '<',
        '>=',
        '<=',
      ]
      this.operatorSelect.forEach((item) => {
        if (stringArr.includes(item.dict_value)) {
          dataSelect.push(item)
        }
      })
      return dataSelect
    },
  },
  created () {
    if (this.defaultSearch) {
      this.showData = this.defaultSearch
    }
  },
  watch: {
    systemFieldMeta: {
      immediate: true,
      handler (val) {
        if (this.systemFieldMetaData.length <= 0) {
          this.systemFieldMetaData = this.systemFieldMeta
        }
      },
      deep: true,
    },
  },
  async mounted () {
    await this.getOperators()
  },

  methods: {
    // 重置多个字段，全部字段
    resetField (val) {
      if (this.resetParams) {
        return true
      } else {
        if (this.resetParamsField && this.resetParamsField == val) {
          return true
        }
      }
      return false
    },
    // 根据字段类型 筛选对应的逻辑运算符
    filterOperators (item) {
      let arr = []
      if (item.field_reference) {
        arr = this.advanceSelect
        return arr
      }
      switch (item.field_type) {
        case 'string':
          arr = this.stringSelect
          break
        case 'int':
          arr = this.intSelect
          break
        case 'datetime':
          arr = this.dateTimeSelect
          break
        default:
          arr = []
      }
      return arr
    },
    // 清空
    cancel () {
      this.searchData = []
      this.showData = []
      this.resetParams = true
      this.$emit('success', [])
      this.drawer = false
      setTimeout(() => {
        this.resetParams = false
        this.panels = []
      }, 1000)
    },
    // 将选择的搜索条件收集起来
    getData (obj) {
      const index = this.searchData.findIndex((item) => {
        return item.field_name == obj.field_name
      })
      index <= -1
        ? this.searchData.push(obj)
        : this.$set(this.searchData, index, obj)
    },
    success () {
      const arr = this.searchData.filter((item) => {
        if (
          item.logical_operator != 'isNull' &&
          item.logical_operator != 'isNotNull'
        ) {
          return String(item.logical_value) != '' && item.logical_operator
        } else {
          return true
        }
        // if (item.logical_value != '' && item.logical_operator) {
        //   arr.push(item)
        // }
      })
      this.showData = [...arr]
      this.$emit('success', arr)
      this.drawer = false
      this.panels = []
    },
    async getOperators () {
      const res = await get_dict_name({ dict_name: 'LogicalOperators' })
      if (res.code == 200) {
        this.operatorSelect = res.data
      }
    },
    close (item, index) {
      const searchDataIndex = this.searchData.findIndex(
        (it) => it.field_name == item.field_name
      )
      this.searchData.splice(searchDataIndex, 1)
      this.showData.splice(index, 1)
      this.resetParamsField = item.field_name

      setTimeout(() => {
        this.resetParamsField = ''
      }, 1000)
      this.$emit('success', this.showData)
    },
  },
}
</script>

<style scoped>
.dv {
  min-height: 56px;
  border-bottom: 1px solid #e0e0e0;
  padding: 0 24px;
  justify-content: space-between !important;
  align-items: center;
  display: flex;
}
.smallRound {
  display: inline-block;
  line-height: 12px;
  text-align: center;
  font-size: 12px;
  width: 14px;
  height: 14px;
  color: #ffffff;
  background: #739ce8;
  border-radius: 50%;
  position: relative;
  top: -3px;
}
.activePanelClass {
  border-left: 4px solid var(--main-color);
}
/deep/ .v-chip-group .v-slide-group__content {
  padding: 0 !important;
}
</style>
